import React from "react";
import indexService, {
  IPostCreateTempDetail,
  IUserinfo,
} from "../../service/Index";
import styles from "../../styles/index";
import icClose from "../../assets/imgs/closeCert.png";
import imgCircle from "../../assets/imgs/img_change_certificate_label@2x.png";
import html2canvas from "html2canvas";
import { bridge, customerShare } from "../../utils/bridge";
import { Loading, Toast } from "codoon-come";
import { jumpToUrlPair } from "./urlTransform";
import { tempBtnColorSelecor } from "../../store/common/selector";
import { connect } from "react-redux";
import { fillUserIdInUrl } from "../../pages/utils";

const { GlobalToast } = Toast;
const { GlobalLoading } = Loading;

type IProps = {
  onClose: () => void;
  user_info: IUserinfo;
  name?: string;
  tempDetail: IPostCreateTempDetail;
  activity_id: string;
} & ReturnType<typeof mapStateToProps>;

interface IState {
  pic_url: string;
  showToast: boolean;
  toastTip: string;
  pop_upyun: string;
  showLoading: boolean;
  isProduced: boolean;
  portrait_upyun: string;
}

class ClubActivityCertModal extends React.Component<IProps, IState> {
  state: IState = {
    pic_url: "",
    showToast: false,
    toastTip: "",
    isProduced: false,
    showLoading: false,
    pop_upyun: "",
    portrait_upyun: "",
  };

  constructor(props: IProps) {
    super(props);
    this.saveImg = this.saveImg.bind(this);
    this.toggleShowToast = this.toggleShowToast.bind(this);
    this.downloadImage = this.downloadImage.bind(this);
  }

  async componentDidMount() {
    await this.uploadPopupImg();
    await this.uploadPortraitImg();
    this.saveImg();
  }

  async uploadPopupImg() {
    const { tempDetail } = this.props;
    const { reword_list } = tempDetail;
    if (!reword_list.cert_img) {
      return;
    }
    return indexService
      .getBase64PicUrl({
        url: reword_list.cert_img,
      })
      .then((response) => {
        if (response.status) {
          this.setState({ pop_upyun: response.data });
        }
      });
  }

  async uploadPortraitImg() {
    const { user_info } = this.props;
    const param = {
      url: user_info.portrait,
    };
    return indexService.getBase64PicUrl(param).then((response) => {
      if (!response.status) return;
      this.setState({
        portrait_upyun: response.data,
      });
    });
  }

  // toast提示
  public toggleShowToast(showToast: boolean, toastTip: string): void {
    this.setState({ showToast, toastTip });
    setTimeout(() => {
      this.setState({ showToast: false, toastTip: "" });
    }, 2000);
  }

  saveImg() {
    const { tempDetail } = this.props;
    const { reword_list } = tempDetail;
    const downloadEl = document.getElementById("certDownload");

    if (reword_list.reward_type === "other" || !downloadEl) return;
    html2canvas(downloadEl, {
      useCORS: true,
      // width: downloadEl?.offsetWidth || 292,//设置canvas尺寸与所截图尺寸相同，防止白边
      // height: downloadEl?.offsetHeight || 415,//防止白边
    }).then((canvas: { toDataURL: (type: string) => string }) => {
      const base64 = canvas.toDataURL("image/png");
      this.uploadCanvasImg(base64);
    });
  }

  // 上传base64图片到又拍云
  uploadCanvasImg(canvasImg: string) {
    const param = { data: canvasImg, type: "image/png" };
    indexService.uploadBase64Img(param).then((response) => {
      if (!response.status) return;
      this.setState(
        {
          isProduced: true,
          pic_url: response.data,
        },
        () => {
          if (this.state.showLoading) {
            this.downloadImage();
            this.setState({ showLoading: false });
          }
        }
      );
    });
  }

  downloadImage() {
    if (
      !bridge.requestAPPVersion() ||
      (bridge.requestAPPVersion().length === 5 &&
        bridge.requestAPPVersion() < "6.3.0")
    ) {
      this.toggleShowToast(true, "当前版本不支持下载图片");
      return;
    }
    // 如果此时图片还没有生成，则展示loading,等待图片生成
    if (!this.state.isProduced) {
      this.setState({ showLoading: true });
      return;
    }
    bridge.nativeDownloadImg(
      { urls: [this.state.pic_url] },
      (err: any, response: any) => {
        if (err) {
          return this.toggleShowToast(true, "下载照片出错，请重试");
        }
        this.toggleShowToast(true, "下载成功");
      }
    );
  }

  // 分享图片
  shareCertImg = () => {
    const { tempDetail } = this.props;
    customerShare({
      sCodoonShareImgUrl: this.state.pic_url,
      sCodoonShareLineLink: window.location.href,
      sCodoonShareTitle: tempDetail.share_param.title,
      sCodoonShareDescContent: tempDetail.share_param.content,
      sCodoonShareCodoonLineLink: window.location.href,
      oCodoonShareDestination: {
        codoonTimeline: true,
        codoonGroup: true,
        weixinToFriend: true,
        weixinToTimeline: true,
        sinaWeibo: false,
        tencentQQ: true,
        tencentQzone: true,
      },
      sCodoonShareContentType: 1,
    });
  };

  /* 往 reward_url 跳转 */
  jumpToRewardUrl = () => {
    const {
      tempDetail: {
        reword_list: { reward_url },
      },
      user_info,
    } = this.props;
    if (reward_url) {
      const fillUrl = fillUserIdInUrl(reward_url, user_info.id || "");
      jumpToUrlPair(fillUrl);
    }
  };

  render() {
    const { tempDetail, onClose, user_info, tempBtnColor } = this.props;
    const { reword_list } = tempDetail;
    const { pop_upyun, portrait_upyun, showLoading } = this.state;

    // 按钮样式
    const certButtonStyle = {
      ...styles.certButton,
      backgroundColor: tempBtnColor,
    };

    /* 证书奖励 弹窗内容 */
    return (
      <div style={styles.certModal}>
        {this.state.showToast && <GlobalToast text={this.state.toastTip} />}
        <GlobalLoading isLoading={showLoading} />
        <div
          style={styles.closeBtn}
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className={"is-clickable"}
        >
          <img src={icClose} style={styles.closeBtnImg} />
        </div>
        <div style={styles.certDownload} id="certDownload">
          <div style={styles.certHead}>
            <img
              src={pop_upyun || reword_list.cert_img}
              style={styles.popCertPoster}
            />
            <div style={styles.certNickContainer}>
              <img
                src={portrait_upyun || user_info.portrait}
                style={styles.certPortrait}
              />
              <p style={styles.certNick}>{user_info.nick}</p>
              <p style={styles.certSlogan}>{reword_list.cert_slogan}</p>
              <p style={styles.certDesc}>{reword_list.cert_desc}</p>
              {reword_list.cer_finish_title && reword_list.cer_finish_desc ? (
                <div style={styles.nameContainer}>
                  <img src={imgCircle} style={styles.nameImg} alt="" />
                  <span style={styles.nameTag}>
                    {reword_list.cer_finish_title}
                  </span>
                  <p style={styles.actName}>{reword_list.cer_finish_desc}</p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div style={styles.certButtonContainer} className="clearfix">
          <div
            style={certButtonStyle}
            onClick={this.downloadImage}
            className={"is-clickable"}
          >
            保存到手机
          </div>
          {reword_list.reward_url ? (
            <div
              style={certButtonStyle}
              onClick={this.jumpToRewardUrl}
              className={"is-clickable"}
            >
              福利派送
            </div>
          ) : (
            <div
              style={certButtonStyle}
              onClick={this.shareCertImg}
              className={"is-clickable"}
            >
              去分享
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    tempBtnColor: tempBtnColorSelecor(state),
  };
};

export default connect(mapStateToProps)(ClubActivityCertModal);
